export class VoteConfig {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.coverImage = form.coverImage; // 投票主图，分享卡片，结束页主图
      this.instructions = form.instructions; // 说明
      this.introduction = form.introduction; // 介绍
      this.time = [form.beginTime, form.endTime];
      this.linkToImage = form.linkToImage; // 链接banner图片
      this.linkToTitle = form.linkToTitle; // 链接标题
      this.linkToUrl = form.linkToUrl; // 链接
      this.multiSelectMax = form.multiSelectMax; // 多选上限(数字)
      this.options = form.options; // 0单选1多选(数字)
      this.rules = form.rules; // 0每人每天一次，1有效期每人一次（数字）
      this.subTitle = form.subTitle; // 副标题
      this.title = form.title; // 主题
      this.voteItemAddDTO = form.voteItemDetailsVOS; // 投票项目
    } else {
      this.clear();
    }
  }

  get time() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set time(time) {
    if (time && Array.isArray(time) && time.length === 2) {
      this.beginTime = time[0];
      this.endTime = time[1];
    } else {
      this.beginTime = "";
      this.endTime = "";
    }
  }

  clear() {
    this.id = '';
    this.coverImage = {};
    this.instructions = '';
    this.linkToImage = '';
    this.linkToTitle = '';
    this.linkToUrl = '';
    this.multiSelectMax = '';
    this.options = 0;
    this.rules = 0;
    this.subTitle = '';
    this.title = '';
    this.voteItemAddDTO = [];
    this.time = [];
  }
}
